import Api from './api';

const LeisService = {
    cadastro: async (params) => {
        const response = await Api.post('/restrito/leis/cadastrar', params, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },

    listar: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/restrito/leis/listar',
            params: params,
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },
    numLeis: async (params) => {
        return Api({
            method: 'get',
            url: '/restrito/leis/numleis',
            params: params,
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
    },
    deletar: (id) => {
        Api.delete(`/restrito/leis/deletar/${id}`, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
    },
    leiEdit: async (id) => {
        const response = await Api.get(`/restrito/leis/editar/${id}`,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    editar: async (id, params) => {
        const response = await Api.put(`/restrito/leis/editar/${id}`,
            params,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    buscar: (params) => {
        const response = Api.get(`/restrito/leis/buscar?${params}`,
            { headers: { 'x-access-token': localStorage.getItem('token') } })

        return response
    },
    arquivo: async (id, ano, params) => {
        const response = await Api.patch(`/restrito/leis/editar/${id}?ano=${ano}`,
            params,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    }
}

export default LeisService;